module.exports = __webpack_public_path__ + "img/解决方案_动力_白.75e3b86c.svg";